// `type="switch"` renders as `<input type="checkbox" role="switch">`, so the handlers
// below match on `type === "checkbox"`.

import * as Popup from "../framework/components/popup";
import { fetchJSON } from "../framework/api";

document.addEventListener("change", async (e) => {
  const toggle = e.target;
  if (toggle.type !== "checkbox" || !("jsFormVisibilityMode" in toggle.dataset)) return;

  const container = toggle.closest("[data-js-form-visibility]");
  if (!container) return;

  const formId = container.dataset.jsFormVisibility;
  // The switch merges both visibility gates, so it can be OFF on a form still in `all` mode: compare
  // against what was rendered, not against the mode alone.
  const wasVisibleToAll = container.dataset.visibleToAll === "true";
  const visibleToAll = toggle.checked;

  if (visibleToAll === wasVisibleToAll) return;
  if (container.classList.contains("is-loading")) return;

  if (visibleToAll) {
    const confirmed = await Popup.confirm(`#popup-form-visibility-all-${formId}`);
    if (!confirmed) {
      toggle.checked = false;
      return;
    }
  }

  container.classList.add("is-loading");
  // Don't re-enable switches the server disabled.
  const inputsToRestore = [...container.querySelectorAll("input")].filter((input) => !input.disabled);
  inputsToRestore.forEach((input) => (input.disabled = true));

  try {
    await fetchJSON(p`/ajax/evaluations/${container.dataset.evaluationId}/form_visibility_mode`, {
      method: "PUT",
      body: { mode: visibleToAll ? "all" : "selected" },
    });

    // Reload so the server renders the guest list matching the new mode, and the extranet address
    window.location.reload();
  } catch (error) {
    console.error("Error while updating form visibility mode", error);
    toggle.checked = wasVisibleToAll;
    container.classList.remove("is-loading");
    inputsToRestore.forEach((input) => (input.disabled = false));
  }
});

document.addEventListener("change", async (e) => {
  const checkbox = e.target;
  if (checkbox.type !== "checkbox" || !("jsFormVisibilityGuest" in checkbox.dataset)) return;

  const container = checkbox.closest("[data-js-form-visibility]");
  if (!container) return;

  const checked = checkbox.checked;
  checkbox.disabled = true;

  try {
    const evaluationId = container.dataset.evaluationId;

    const { published } = await fetchJSON(p`/ajax/evaluations/${evaluationId}/form_visibility_guest`, {
      method: "PUT",
      body: {
        guest_type: checkbox.dataset.guestType,
        guest_id: checkbox.dataset.guestId,
        granted: checked,
      },
    });

    // Granting the first guest publishes the evaluation, which resolves it (see `evaluation.ex`)
    if (published) document.dispatchEvent(new CustomEvent("evaluation-resolved", { detail: { id: evaluationId } }));
  } catch (error) {
    console.error("Error while updating form visibility grant", error);
    checkbox.checked = !checked;
  } finally {
    checkbox.disabled = false;
  }
});
